/**
 * @lodex-pro/shared/auth/device-modes — DeviceMode pinned const + union type.
 *
 * Phase 4 / Plan 02 — D-09 / D-10 / D-11. Mirrors Phase 2 D-08
 * (JOB_STATUS_CODES against job_statuses) and Phase 3 D-06 (ROLE_CODES
 * against default_roles) pinned-const pattern.
 *
 * Three device modes:
 *   - PERSONAL — a driver's own phone (single-user device, biometric login)
 *   - SHARED   — a tablet shared across drivers on the same tenant (roster + PIN)
 *   - WEB      — desktop browser session (dispatch, billing, operator portal)
 *
 * Locked: Plan 04-04's `cognitoJwtPlugin` extension ships
 * `assertDeviceModesHealthy()` as a boot-time check — it reads
 * `pg_constraint.conkey` for the `user_devices_mode_check` CHECK constraint
 * and asserts the IN-clause matches this DEVICE_MODES literal list. If the
 * SQL CHECK drifts from the TS const (e.g. a forgotten ALTER), server start
 * fails loud rather than letting a future row land with a stale mode.
 *
 * Spec: master spec §7 (auth flows per device mode), CONTEXT D-08 / D-09 /
 *       D-10 / D-11. Migration: 0003_phase4_auth_tables.sql.
 */

export const DEVICE_MODES = ['PERSONAL', 'SHARED', 'WEB'] as const;

export type DeviceMode = (typeof DEVICE_MODES)[number];
